import { SearchIcon, XIcon } from "lucide-react";
import {
  SearchField as AriaSearchField,
  type SearchFieldProps as AriaSearchFieldProps,
  type ValidationResult,
} from "react-aria-components";

import { Button } from "./button";
import { Description, FieldError, FieldGroup, Input, Label } from "./field";
import { composeTailwindRenderProps } from "./utils";

export interface SearchFieldProps extends AriaSearchFieldProps {
  label?: string;
  description?: string;
  placeholder?: string;
  errorMessage?: string | ((validation: ValidationResult) => string);
}

export function SearchField({
  label,
  description,
  placeholder,
  errorMessage,
  ...props
}: SearchFieldProps) {
  return (
    <AriaSearchField
      {...props}
      className={composeTailwindRenderProps(
        props.className,
        "group flex flex-col gap-1 min-w-10",
      )}
    >
      {label && <Label>{label}</Label>}

      <FieldGroup>
        <SearchIcon
          aria-hidden
          className="ml-2 h-4 w-4 text-gray-500 group-disabled:text-gray-200 forced-colors:text-[ButtonText] forced-colors:group-disabled:text-[GrayText]"
        />

        <Input
          placeholder={placeholder}
          className="[&::-webkit-search-cancel-button]:hidden"
        />

        {props.value && (
          <Button variant="text" className="mr-1 w-6 group-empty:invisible">
            <XIcon aria-hidden className="h-4 w-4" />
          </Button>
        )}
      </FieldGroup>

      {description && <Description>{description}</Description>}

      <FieldError>{errorMessage}</FieldError>
    </AriaSearchField>
  );
}
